<template>
  <section class="page-offset overflow-hidden pb-8 lg:pb-20">
    <div class="container">
      <h2 class="heading">
        {{ $t('News') }}
      </h2>
      <AmbitionSelect
        v-model:selection="selectedId"
        :ambitions="ambitions"
      />
      <div class="pt-4 lg:pt-14">
        <NewsList :articles="articles" />
      </div>
      <Btn
        class="text-center"
        :label="$t('Load more news')"
        :short-label="$t('More news')"
        @click="articlesFetchMore"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import {useArticles} from '~/composables/useArticles';
import {useRouteQuery} from '@vueuse/router';
import {useAmbitionsQuery} from '~/graphql/graphql';

const {articles, articlesUpdateVariables, articlesFetchMore} = useArticles();
const {result} = useAmbitionsQuery();
const ambitions = computed(() => result.value?.ambitions ?? []);

const selectedIdQuery = useRouteQuery<string | undefined>('ambition', undefined, {
  mode: 'push',
});

const selectedId = computed({
  get: () => selectedIdQuery.value ? Number(selectedIdQuery.value) : undefined,
  set: (value: number | undefined) => selectedIdQuery.value = value ? '' + value : undefined,
});

watch(selectedId, () => articlesUpdateVariables({ambition_id: selectedId.value}));
</script>
